import { Product } from '@/types/product';
import { getDemoImage } from './demoImages';

// Helper function to get image path with fallback
const getImagePath = (category: string, productName: string, imageName: string = 'main.jpg') => {
  const baseUrl = `/products/${category}`;
  const productSlug = productName.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  return `${baseUrl}/${productSlug}-${imageName}`;
};

// Helper function to create placeholder image
const getPlaceholderImage = (category: string, productName: string, width = 400, height = 300) => {
  const text = encodeURIComponent(productName.split(' ')[0]);
  return `https://via.placeholder.com/${width}x${height}/1f2937/a3a3a3?text=${text}`;
};

// Enhanced product data structure for all 18 products
export const enhancedProducts: Product[] = [
  // MEN'S APPAREL (6 products)
  {
    id: 'pbx-strike-shirt',
    shopifyProductId: '8755661799662',
    name: 'PBX "Strike" High-Performance Dry Fit Shirt',
    description: 'Introducing PBX - Unisex High Performance Shirt | Cooling Performance Crew, designed for optimal comfort and durability. Crafted with 4.0-ounce micro poly interlock, this shirt offers superior moisture-wicking and UV protection with a UPF 44+ rating.',
    price: 35,
    images: {
      main: '/products/shirts/pbx shirt 2.webp',
      gallery: [
        '/products/shirts/pbx shirt 2.webp',
        getPlaceholderImage('mens', 'PBX Strike Back'),
        getPlaceholderImage('mens', 'PBX Strike Detail')
      ]
    },
    category: 'mens',
    subcategory: 'shirts',
    variants: [
      { size: 'XS', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273470562542', available: true, price: 35 },
      { size: 'S', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273470562542', available: true, price: 35 },
      { size: 'M', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273470562542', available: true, price: 35 },
      { size: 'L', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273470562542', available: true, price: 35 },
      { size: 'XL', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273470562542', available: true, price: 35 },
      { size: 'XS', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273470595310', available: true, price: 35 },
      { size: 'S', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273470595310', available: true, price: 35 },
      { size: 'M', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273470595310', available: true, price: 35 },
      { size: 'L', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273470595310', available: true, price: 35 },
      { size: 'XL', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273470595310', available: true, price: 35 },
      { size: 'XS', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273470628078', available: true, price: 35 },
      { size: 'S', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273470628078', available: true, price: 35 },
      { size: 'M', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273470628078', available: true, price: 35 },
      { size: 'L', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273470628078', available: true, price: 35 },
      { size: 'XL', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273470628078', available: true, price: 35 },
      { size: 'XS', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273470660846', available: true, price: 35 },
      { size: 'S', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273470660846', available: true, price: 35 },
      { size: 'M', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273470660846', available: true, price: 35 },
      { size: 'L', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273470660846', available: true, price: 35 },
      { size: 'XL', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273470660846', available: true, price: 35 },
      { size: 'XS', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273470693614', available: true, price: 35 },
      { size: 'S', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273470693614', available: true, price: 35 },
      { size: 'M', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273470693614', available: true, price: 35 },
      { size: 'L', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273470693614', available: true, price: 35 },
      { size: 'XL', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273470693614', available: true, price: 35 },
      { size: 'XS', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273470726382', available: true, price: 35 },
      { size: 'S', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273470726382', available: true, price: 35 },
      { size: 'M', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273470726382', available: true, price: 35 },
      { size: 'L', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273470726382', available: true, price: 35 },
      { size: 'XL', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273470726382', available: true, price: 35 },
      { size: 'XS', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273470759150', available: true, price: 35 },
      { size: 'S', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273470759150', available: true, price: 35 },
      { size: 'M', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273470759150', available: true, price: 35 },
      { size: 'L', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273470759150', available: true, price: 35 },
      { size: 'XL', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273470759150', available: true, price: 35 },
      { size: 'XS', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273470791918', available: true, price: 35 },
      { size: 'S', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273470791918', available: true, price: 35 },
      { size: 'M', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273470791918', available: true, price: 35 },
      { size: 'L', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273470791918', available: true, price: 35 },
      { size: 'XL', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273470791918', available: true, price: 35 },
      { size: 'XS', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273470824686', available: true, price: 35 },
      { size: 'S', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273470824686', available: true, price: 35 },
      { size: 'M', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273470824686', available: true, price: 35 },
      { size: 'L', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273470824686', available: true, price: 35 },
      { size: 'XL', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273470824686', available: true, price: 35 }
    ],
    features: ['4.0-ounce micro poly interlock', 'Superior moisture-wicking', 'UPF 44+ UV protection', 'Ultra-light knit resists stains', 'Unisex sizing'],
    badge: 'NEW',
    featured: true,
    rating: 4.9,
    reviewCount: 45
  },
  {
    id: 'pbx-shield-shirt',
    shopifyProductId: '8763979596014',
    name: 'PBX "Shield" High-Performance Dry Fit',
    description: 'Introducing PBX - Unisex High Performance Shirt V2 - Cooling Performance Crew, designed for optimal comfort and durability. Features moisture-wicking properties with UPF 44+ rating and ultra-light knit that resists stains.',
    price: 35,
    images: {
      main: '/products/shirts/pbx shirt.jpeg',
      gallery: [
        '/products/shirts/pbx shirt.jpeg',
        getPlaceholderImage('mens', 'PBX Shield Back'),
        getPlaceholderImage('mens', 'PBX Shield Detail')
      ]
    },
    category: 'mens',
    subcategory: 'shirts',
    variants: [
      { size: 'XS', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273471840494', available: true, price: 35 },
      { size: 'S', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273471840494', available: true, price: 35 },
      { size: 'M', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273471840494', available: true, price: 35 },
      { size: 'L', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273471840494', available: true, price: 35 },
      { size: 'XL', color: 'Black', shopifyVariantId: 'gid://shopify/ProductVariant/46273471840494', available: true, price: 35 },
      { size: 'XS', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273471873262', available: true, price: 35 },
      { size: 'S', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273471873262', available: true, price: 35 },
      { size: 'M', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273471873262', available: true, price: 35 },
      { size: 'L', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273471873262', available: true, price: 35 },
      { size: 'XL', color: 'White', shopifyVariantId: 'gid://shopify/ProductVariant/46273471873262', available: true, price: 35 },
      { size: 'XS', color: 'Gray', shopifyVariantId: 'gid://shopify/ProductVariant/46273471906030', available: true, price: 35 },
      { size: 'S', color: 'Gray', shopifyVariantId: 'gid://shopify/ProductVariant/46273471906030', available: true, price: 35 },
      { size: 'M', color: 'Gray', shopifyVariantId: 'gid://shopify/ProductVariant/46273471906030', available: true, price: 35 },
      { size: 'L', color: 'Gray', shopifyVariantId: 'gid://shopify/ProductVariant/46273471906030', available: true, price: 35 },
      { size: 'XL', color: 'Gray', shopifyVariantId: 'gid://shopify/ProductVariant/46273471906030', available: true, price: 35 },
      { size: 'XS', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273471938798', available: true, price: 35 },
      { size: 'S', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273471938798', available: true, price: 35 },
      { size: 'M', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273471938798', available: true, price: 35 },
      { size: 'L', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273471938798', available: true, price: 35 },
      { size: 'XL', color: 'Yellow', shopifyVariantId: 'gid://shopify/ProductVariant/46273471938798', available: true, price: 35 },
      { size: 'XS', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273471971566', available: true, price: 35 },
      { size: 'S', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273471971566', available: true, price: 35 },
      { size: 'M', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273471971566', available: true, price: 35 },
      { size: 'L', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273471971566', available: true, price: 35 },
      { size: 'XL', color: 'Red', shopifyVariantId: 'gid://shopify/ProductVariant/46273471971566', available: true, price: 35 },
      { size: 'XS', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273472004334', available: true, price: 35 },
      { size: 'S', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273472004334', available: true, price: 35 },
      { size: 'M', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273472004334', available: true, price: 35 },
      { size: 'L', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273472004334', available: true, price: 35 },
      { size: 'XL', color: 'Orange', shopifyVariantId: 'gid://shopify/ProductVariant/46273472004334', available: true, price: 35 },
      { size: 'XS', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273472037102', available: true, price: 35 },
      { size: 'S', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273472037102', available: true, price: 35 },
      { size: 'M', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273472037102', available: true, price: 35 },
      { size: 'L', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273472037102', available: true, price: 35 },
      { size: 'XL', color: 'Green', shopifyVariantId: 'gid://shopify/ProductVariant/46273472037102', available: true, price: 35 },
      { size: 'XS', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273472069870', available: true, price: 35 },
      { size: 'S', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273472069870', available: true, price: 35 },
      { size: 'M', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273472069870', available: true, price: 35 },
      { size: 'L', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273472069870', available: true, price: 35 },
      { size: 'XL', color: 'Purple', shopifyVariantId: 'gid://shopify/ProductVariant/46273472069870', available: true, price: 35 },
      { size: 'XS', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273472102638', available: true, price: 35 },
      { size: 'S', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273472102638', available: true, price: 35 },
      { size: 'M', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273472102638', available: true, price: 35 },
      { size: 'L', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273472102638', available: true, price: 35 },
      { size: 'XL', color: 'Pink', shopifyVariantId: 'gid://shopify/ProductVariant/46273472102638', available: true, price: 35 },
      { size: 'XS', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273472135406', available: true, price: 35 },
      { size: 'S', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273472135406', available: true, price: 35 },
      { size: 'M', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273472135406', available: true, price: 35 },
      { size: 'L', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273472135406', available: true, price: 35 },
      { size: 'XL', color: 'Blue', shopifyVariantId: 'gid://shopify/ProductVariant/46273472135406', available: true, price: 35 }
    ],
    features: ['4.0-ounce micro poly interlock', 'Moisture-wicking properties', 'UPF 44+ rating', 'Ultra-light knit resists stains', 'Perfect for active lifestyles'],
    badge: 'NEW',
    featured: true,
    rating: 4.8,
    reviewCount: 32
  },
  {
    id: 'mens-cooling-crew',
    shopifyProductId: 'cooling-performance-crew-mens',
    name: 'Cooling Performance Crew',
    description: 'Advanced moisture-wicking crew neck with cooling technology and adaptive design features.',
    price: 42,
    originalPrice: 55,
    images: {
      main: getDemoImage('cooling-performance-crew', 'main'),
      gallery: [
        getDemoImage('cooling-performance-crew', 'front'),
        getDemoImage('cooling-performance-crew', 'back'),
        getDemoImage('cooling-performance-crew', 'detail')
      ]
    },
    category: 'mens',
    subcategory: 'shirts',
    variants: [
      { size: 'XS', color: 'Navy', shopifyVariantId: 'crew-xs-navy', available: true, price: 42 },
      { size: 'S', color: 'Navy', shopifyVariantId: 'crew-s-navy', available: true, price: 42 },
      { size: 'M', color: 'Navy', shopifyVariantId: 'crew-m-navy', available: true, price: 42 },
      { size: 'L', color: 'Navy', shopifyVariantId: 'crew-l-navy', available: true, price: 42 },
      { size: 'XL', color: 'Navy', shopifyVariantId: 'crew-xl-navy', available: true, price: 42 },
      { size: 'XS', color: 'Gray', shopifyVariantId: 'crew-xs-gray', available: true, price: 42 },
      { size: 'S', color: 'Gray', shopifyVariantId: 'crew-s-gray', available: true, price: 42 },
      { size: 'M', color: 'Gray', shopifyVariantId: 'crew-m-gray', available: true, price: 42 },
      { size: 'L', color: 'Gray', shopifyVariantId: 'crew-l-gray', available: false, price: 42 },
      { size: 'XL', color: 'Gray', shopifyVariantId: 'crew-xl-gray', available: true, price: 42 }
    ],
    features: ['Moisture-wicking technology', 'UPF 50+ sun protection', 'Adaptive magnetic closures', 'Cooling fabric technology'],
    badge: 'BESTSELLER',
    featured: true,
    rating: 4.8,
    reviewCount: 156
  },
  {
    id: 'mens-classic-tshirt',
    shopifyProductId: 'next-level-classic-mens',
    name: 'Next Level Classic PBX T-Shirt',
    description: 'Premium cotton blend t-shirt with modern fit and signature PBX branding.',
    price: 28,
    originalPrice: 35,
    images: {
      main: getImagePath('mens', 'classic-tshirt'),
      gallery: [
        getImagePath('mens', 'classic-tshirt', 'front.jpg'),
        getImagePath('mens', 'classic-tshirt', 'back.jpg'),
        getImagePath('mens', 'classic-tshirt', 'logo-detail.jpg')
      ]
    },
    category: 'mens',
    subcategory: 'shirts',
    variants: [
      { size: 'XS', color: 'Black', shopifyVariantId: 'classic-xs-black', available: true, price: 28 },
      { size: 'S', color: 'Black', shopifyVariantId: 'classic-s-black', available: true, price: 28 },
      { size: 'M', color: 'Black', shopifyVariantId: 'classic-m-black', available: true, price: 28 },
      { size: 'L', color: 'Black', shopifyVariantId: 'classic-l-black', available: true, price: 28 },
      { size: 'XL', color: 'Black', shopifyVariantId: 'classic-xl-black', available: true, price: 28 },
      { size: 'XS', color: 'White', shopifyVariantId: 'classic-xs-white', available: true, price: 28 },
      { size: 'S', color: 'White', shopifyVariantId: 'classic-s-white', available: true, price: 28 },
      { size: 'M', color: 'White', shopifyVariantId: 'classic-m-white', available: false, price: 28 },
      { size: 'L', color: 'White', shopifyVariantId: 'classic-l-white', available: true, price: 28 },
      { size: 'XL', color: 'White', shopifyVariantId: 'classic-xl-white', available: true, price: 28 }
    ],
    features: ['100% premium cotton', 'Modern athletic fit', 'Reinforced seams', 'Signature PBX logo'],
    badge: 'NEW',
    featured: true,
    rating: 4.6,
    reviewCount: 89
  },
  {
    id: 'mens-hooded-zip',
    shopifyProductId: 'sport-tek-hoodie-mens',
    name: 'Embroidered Sport-Tek PosiCharge Strive Hooded Full-Zip',
    description: 'Professional-grade full-zip hoodie with premium embroidery and performance fabric.',
    price: 68,
    images: {
      main: getDemoImage('sport-tek-hoodie', 'main'),
      gallery: [
        getDemoImage('sport-tek-hoodie', 'front'),
        getDemoImage('sport-tek-hoodie', 'embroidery'),
        getDemoImage('sport-tek-hoodie', 'texture')
      ]
    },
    category: 'mens',
    subcategory: 'hoodies',
    variants: [
      { size: 'XS', color: 'Navy', shopifyVariantId: 'hoodie-xs-navy', available: true, price: 68 },
      { size: 'S', color: 'Navy', shopifyVariantId: 'hoodie-s-navy', available: true, price: 68 },
      { size: 'M', color: 'Navy', shopifyVariantId: 'hoodie-m-navy', available: true, price: 68 },
      { size: 'L', color: 'Navy', shopifyVariantId: 'hoodie-l-navy', available: true, price: 68 },
      { size: 'XL', color: 'Navy', shopifyVariantId: 'hoodie-xl-navy', available: true, price: 68 },
      { size: 'XS', color: 'Gray', shopifyVariantId: 'hoodie-xs-gray', available: true, price: 68 },
      { size: 'S', color: 'Gray', shopifyVariantId: 'hoodie-s-gray', available: true, price: 68 },
      { size: 'M', color: 'Gray', shopifyVariantId: 'hoodie-m-gray', available: true, price: 68 },
      { size: 'L', color: 'Gray', shopifyVariantId: 'hoodie-l-gray', available: true, price: 68 },
      { size: 'XL', color: 'Gray', shopifyVariantId: 'hoodie-xl-gray', available: false, price: 68 }
    ],
    features: ['PosiCharge technology', 'Moisture-wicking performance', 'Premium embroidered logo', 'Athletic comfort fit'],
    badge: 'PREMIUM',
    featured: false,
    rating: 4.9,
    reviewCount: 203
  },
  {
    id: 'mens-athletic-shorts',
    shopifyProductId: 'mens-running-shorts',
    name: '2-in-1 Men\'s Running and Athletic Shorts',
    description: 'Dual-layer performance shorts with built-in compression and moisture management.',
    price: 48,
    images: {
      main: getImagePath('mens', 'running-shorts'),
      gallery: [
        getImagePath('mens', 'running-shorts', 'front.jpg'),
        getImagePath('mens', 'running-shorts', 'side.jpg'),
        getImagePath('mens', 'running-shorts', 'compression.jpg')
      ]
    },
    category: 'mens',
    subcategory: 'shorts',
    variants: [
      { size: 'XS', color: 'Black', shopifyVariantId: 'shorts-xs-black', available: true, price: 48 },
      { size: 'S', color: 'Black', shopifyVariantId: 'shorts-s-black', available: true, price: 48 },
      { size: 'M', color: 'Black', shopifyVariantId: 'shorts-m-black', available: true, price: 48 },
      { size: 'L', color: 'Black', shopifyVariantId: 'shorts-l-black', available: true, price: 48 },
      { size: 'XL', color: 'Black', shopifyVariantId: 'shorts-xl-black', available: true, price: 48 },
      { size: 'XS', color: 'Navy', shopifyVariantId: 'shorts-xs-navy', available: true, price: 48 },
      { size: 'S', color: 'Navy', shopifyVariantId: 'shorts-s-navy', available: true, price: 48 },
      { size: 'M', color: 'Navy', shopifyVariantId: 'shorts-m-navy', available: true, price: 48 },
      { size: 'L', color: 'Navy', shopifyVariantId: 'shorts-l-navy', available: false, price: 48 },
      { size: 'XL', color: 'Navy', shopifyVariantId: 'shorts-xl-navy', available: true, price: 48 }
    ],
    features: ['2-in-1 design with compression liner', 'Quick-dry fabric', 'Secure zip pockets', 'Anti-chafe technology'],
    badge: 'BESTSELLER',
    featured: true,
    rating: 4.7,
    reviewCount: 134
  },

  // WOMEN'S APPAREL (5 products)
  {
    id: 'womens-cooling-crew',
    shopifyProductId: 'cooling-performance-crew-womens',
    name: 'Cooling Performance Crew',
    description: 'Women\'s fit cooling crew with feminine cut and performance technology.',
    price: 42,
    originalPrice: 55,
    images: {
      main: getImagePath('womens', 'cooling-performance-crew'),
      gallery: [
        getImagePath('womens', 'cooling-performance-crew', 'front.jpg'),
        getImagePath('womens', 'cooling-performance-crew', 'back.jpg'),
        getImagePath('womens', 'cooling-performance-crew', 'fit.jpg')
      ]
    },
    category: 'womens',
    subcategory: 'shirts',
    variants: [
      { size: 'XS', color: 'Sage', shopifyVariantId: 'wcrew-xs-sage', available: true, price: 42 },
      { size: 'S', color: 'Sage', shopifyVariantId: 'wcrew-s-sage', available: true, price: 42 },
      { size: 'M', color: 'Sage', shopifyVariantId: 'wcrew-m-sage', available: true, price: 42 },
      { size: 'L', color: 'Sage', shopifyVariantId: 'wcrew-l-sage', available: true, price: 42 },
      { size: 'XL', color: 'Sage', shopifyVariantId: 'wcrew-xl-sage', available: true, price: 42 },
      { size: 'XS', color: 'Coral', shopifyVariantId: 'wcrew-xs-coral', available: true, price: 42 },
      { size: 'S', color: 'Coral', shopifyVariantId: 'wcrew-s-coral', available: false, price: 42 },
      { size: 'M', color: 'Coral', shopifyVariantId: 'wcrew-m-coral', available: true, price: 42 },
      { size: 'L', color: 'Coral', shopifyVariantId: 'wcrew-l-coral', available: true, price: 42 },
      { size: 'XL', color: 'Coral', shopifyVariantId: 'wcrew-xl-coral', available: true, price: 42 }
    ],
    features: ['Women\'s tailored fit', 'Cooling fabric technology', 'UPF 50+ protection', 'Adaptive design elements'],
    badge: 'BESTSELLER',
    featured: true,
    rating: 4.8,
    reviewCount: 198
  },
  {
    id: 'womens-classic-tshirt',
    shopifyProductId: 'next-level-classic-womens',
    name: 'Next Level Classic PBX T-Shirt',
    description: 'Women\'s premium cotton tee with flattering fit and soft hand feel.',
    price: 28,
    originalPrice: 35,
    images: {
      main: getImagePath('womens', 'classic-tshirt'),
      gallery: [
        getImagePath('womens', 'classic-tshirt', 'front.jpg'),
        getImagePath('womens', 'classic-tshirt', 'back.jpg'),
        getImagePath('womens', 'classic-tshirt', 'detail.jpg')
      ]
    },
    category: 'womens',
    subcategory: 'shirts',
    variants: [
      { size: 'XS', color: 'Vintage White', shopifyVariantId: 'wclassic-xs-white', available: true, price: 28 },
      { size: 'S', color: 'Vintage White', shopifyVariantId: 'wclassic-s-white', available: true, price: 28 },
      { size: 'M', color: 'Vintage White', shopifyVariantId: 'wclassic-m-white', available: true, price: 28 },
      { size: 'L', color: 'Vintage White', shopifyVariantId: 'wclassic-l-white', available: true, price: 28 },
      { size: 'XL', color: 'Vintage White', shopifyVariantId: 'wclassic-xl-white', available: true, price: 28 },
      { size: 'XS', color: 'Heather Gray', shopifyVariantId: 'wclassic-xs-gray', available: true, price: 28 },
      { size: 'S', color: 'Heather Gray', shopifyVariantId: 'wclassic-s-gray', available: true, price: 28 },
      { size: 'M', color: 'Heather Gray', shopifyVariantId: 'wclassic-m-gray', available: false, price: 28 },
      { size: 'L', color: 'Heather Gray', shopifyVariantId: 'wclassic-l-gray', available: true, price: 28 },
      { size: 'XL', color: 'Heather Gray', shopifyVariantId: 'wclassic-xl-gray', available: true, price: 28 }
    ],
    features: ['Feminine cut and fit', 'Ultra-soft cotton blend', 'Relaxed comfort', 'Signature logo placement'],
    badge: 'NEW',
    featured: true,
    rating: 4.7,
    reviewCount: 145
  },
  {
    id: 'womens-hooded-zip',
    shopifyProductId: 'sport-tek-hoodie-womens',
    name: 'Embroidered Sport-Tek PosiCharge Strive Hooded Full-Zip',
    description: 'Women\'s performance hoodie with tailored fit and premium construction.',
    price: 68,
    images: {
      main: getImagePath('womens', 'sport-tek-hoodie'),
      gallery: [
        getImagePath('womens', 'sport-tek-hoodie', 'front.jpg'),
        getImagePath('womens', 'sport-tek-hoodie', 'embroidery.jpg'),
        getImagePath('womens', 'sport-tek-hoodie', 'fit.jpg')
      ]
    },
    category: 'womens',
    subcategory: 'hoodies',
    variants: [
      { size: 'XS', color: 'Deep Navy', shopifyVariantId: 'whoodie-xs-navy', available: true, price: 68 },
      { size: 'S', color: 'Deep Navy', shopifyVariantId: 'whoodie-s-navy', available: true, price: 68 },
      { size: 'M', color: 'Deep Navy', shopifyVariantId: 'whoodie-m-navy', available: true, price: 68 },
      { size: 'L', color: 'Deep Navy', shopifyVariantId: 'whoodie-l-navy', available: true, price: 68 },
      { size: 'XL', color: 'Deep Navy', shopifyVariantId: 'whoodie-xl-navy', available: true, price: 68 },
      { size: 'XS', color: 'Stone Gray', shopifyVariantId: 'whoodie-xs-gray', available: true, price: 68 },
      { size: 'S', color: 'Stone Gray', shopifyVariantId: 'whoodie-s-gray', available: true, price: 68 },
      { size: 'M', color: 'Stone Gray', shopifyVariantId: 'whoodie-m-gray', available: true, price: 68 },
      { size: 'L', color: 'Stone Gray', shopifyVariantId: 'whoodie-l-gray', available: false, price: 68 },
      { size: 'XL', color: 'Stone Gray', shopifyVariantId: 'whoodie-xl-gray', available: true, price: 68 }
    ],
    features: ['Women\'s contoured fit', 'PosiCharge moisture-wicking', 'Premium embroidered details', 'Athletic performance fabric'],
    badge: 'PREMIUM',
    featured: false,
    rating: 4.9,
    reviewCount: 167
  },
  {
    id: 'womens-crop-tops',
    shopifyProductId: 'womens-cooling-crop-tops',
    name: 'Women\'s Cooling Performance Crop Tops',
    description: 'High-performance crop tops with cooling technology and supportive fit.',
    price: 38,
    originalPrice: 48,
    images: {
      main: getDemoImage('cooling-crop-top', 'main'),
      gallery: [
        getDemoImage('cooling-crop-top', 'front'),
        getDemoImage('cooling-crop-top', 'back'),
        getDemoImage('cooling-crop-top', 'action')
      ]
    },
    category: 'womens',
    subcategory: 'activewear',
    variants: [
      { size: 'XS', color: 'Sunset Pink', shopifyVariantId: 'wcrop-xs-pink', available: true, price: 38 },
      { size: 'S', color: 'Sunset Pink', shopifyVariantId: 'wcrop-s-pink', available: true, price: 38 },
      { size: 'M', color: 'Sunset Pink', shopifyVariantId: 'wcrop-m-pink', available: true, price: 38 },
      { size: 'L', color: 'Sunset Pink', shopifyVariantId: 'wcrop-l-pink', available: true, price: 38 },
      { size: 'XL', color: 'Sunset Pink', shopifyVariantId: 'wcrop-xl-pink', available: true, price: 38 },
      { size: 'XS', color: 'Ocean Blue', shopifyVariantId: 'wcrop-xs-blue', available: true, price: 38 },
      { size: 'S', color: 'Ocean Blue', shopifyVariantId: 'wcrop-s-blue', available: false, price: 38 },
      { size: 'M', color: 'Ocean Blue', shopifyVariantId: 'wcrop-m-blue', available: true, price: 38 },
      { size: 'L', color: 'Ocean Blue', shopifyVariantId: 'wcrop-l-blue', available: true, price: 38 },
      { size: 'XL', color: 'Ocean Blue', shopifyVariantId: 'wcrop-xl-blue', available: true, price: 38 }
    ],
    features: ['Cooling fabric technology', 'Built-in support', 'Moisture-wicking performance', 'Flattering crop cut'],
    badge: 'NEW',
    featured: true,
    rating: 4.6,
    reviewCount: 98
  },
  {
    id: 'womens-running-skirts',
    shopifyProductId: 'womens-running-skirts',
    name: 'Women\'s 2-in-1 Running Skirts',
    description: 'Performance running skirts with built-in shorts and secure storage.',
    price: 52,
    images: {
      main: getImagePath('womens', 'running-skirt'),
      gallery: [
        getImagePath('womens', 'running-skirt', 'front.jpg'),
        getImagePath('womens', 'running-skirt', 'side.jpg'),
        getImagePath('womens', 'running-skirt', 'motion.jpg')
      ]
    },
    category: 'womens',
    subcategory: 'activewear',
    variants: [
      { size: 'XS', color: 'Midnight Black', shopifyVariantId: 'wskirt-xs-black', available: true, price: 52 },
      { size: 'S', color: 'Midnight Black', shopifyVariantId: 'wskirt-s-black', available: true, price: 52 },
      { size: 'M', color: 'Midnight Black', shopifyVariantId: 'wskirt-m-black', available: true, price: 52 },
      { size: 'L', color: 'Midnight Black', shopifyVariantId: 'wskirt-l-black', available: true, price: 52 },
      { size: 'XL', color: 'Midnight Black', shopifyVariantId: 'wskirt-xl-black', available: true, price: 52 },
      { size: 'XS', color: 'Athletic Navy', shopifyVariantId: 'wskirt-xs-navy', available: true, price: 52 },
      { size: 'S', color: 'Athletic Navy', shopifyVariantId: 'wskirt-s-navy', available: true, price: 52 },
      { size: 'M', color: 'Athletic Navy', shopifyVariantId: 'wskirt-m-navy', available: false, price: 52 },
      { size: 'L', color: 'Athletic Navy', shopifyVariantId: 'wskirt-l-navy', available: true, price: 52 },
      { size: 'XL', color: 'Athletic Navy', shopifyVariantId: 'wskirt-xl-navy', available: true, price: 52 }
    ],
    features: ['2-in-1 design with built-in shorts', 'Secure zip pockets', 'Moisture-wicking fabric', 'Athletic performance fit'],
    badge: 'BESTSELLER',
    featured: true,
    rating: 4.8,
    reviewCount: 176
  },

  // ACCESSORIES (9 products)
  {
    id: 'compression-arm-sleeves',
    shopifyProductId: 'pbx-compression-arm-sleeves',
    name: 'PBX Compression Arm Sleeves',
    description: 'Professional-grade compression sleeves for enhanced performance and recovery.',
    price: 24,
    images: {
      main: getImagePath('accessories', 'compression-arm-sleeves'),
      gallery: [
        getImagePath('accessories', 'compression-arm-sleeves', 'pair.jpg'),
        getImagePath('accessories', 'compression-arm-sleeves', 'detail.jpg'),
        getImagePath('accessories', 'compression-arm-sleeves', 'wearing.jpg')
      ]
    },
    category: 'accessories',
    subcategory: 'performance',
    variants: [
      { size: 'S/M', shopifyVariantId: 'sleeves-sm', available: true, price: 24 },
      { size: 'L/XL', shopifyVariantId: 'sleeves-lxl', available: true, price: 24 }
    ],
    features: ['Graduated compression', 'Moisture-wicking fabric', 'UV protection', 'Ergonomic design'],
    badge: 'BESTSELLER',
    featured: false,
    rating: 4.7,
    reviewCount: 89
  },
  {
    id: 'athletic-knee-socks',
    shopifyProductId: 'pbx-athletic-knee-socks',
    name: 'PBX Athletic Knee-High Socks',
    description: 'Premium performance socks with targeted cushioning and moisture management.',
    price: 18,
    images: {
      main: getImagePath('accessories', 'athletic-knee-socks'),
      gallery: [
        getImagePath('accessories', 'athletic-knee-socks', 'pair.jpg'),
        getImagePath('accessories', 'athletic-knee-socks', 'detail.jpg'),
        getImagePath('accessories', 'athletic-knee-socks', 'colors.jpg')
      ]
    },
    category: 'accessories',
    subcategory: 'performance',
    variants: [
      { size: 'S', color: 'White/Lime', shopifyVariantId: 'socks-s-white', available: true, price: 18 },
      { size: 'M', color: 'White/Lime', shopifyVariantId: 'socks-m-white', available: true, price: 18 },
      { size: 'L', color: 'White/Lime', shopifyVariantId: 'socks-l-white', available: true, price: 18 },
      { size: 'S', color: 'Black/Gray', shopifyVariantId: 'socks-s-black', available: true, price: 18 },
      { size: 'M', color: 'Black/Gray', shopifyVariantId: 'socks-m-black', available: false, price: 18 },
      { size: 'L', color: 'Black/Gray', shopifyVariantId: 'socks-l-black', available: true, price: 18 }
    ],
    features: ['Targeted cushioning zones', 'Moisture-wicking technology', 'Reinforced heel and toe', 'Compression support'],
    badge: 'NEW',
    featured: false,
    rating: 4.5,
    reviewCount: 67
  },
  {
    id: 'club-embroidered-hats',
    shopifyProductId: 'pbx-club-embroidered-hats',
    name: 'PBX Club Embroidered Hats',
    description: 'Premium structured hats with detailed embroidery and adjustable fit.',
    price: 32,
    images: {
      main: getImagePath('accessories', 'embroidered-hat'),
      gallery: [
        getImagePath('accessories', 'embroidered-hat', 'front.jpg'),
        getImagePath('accessories', 'embroidered-hat', 'side.jpg'),
        getImagePath('accessories', 'embroidered-hat', 'embroidery.jpg')
      ]
    },
    category: 'accessories',
    subcategory: 'headwear',
    variants: [
      { color: 'Navy/White', shopifyVariantId: 'hat-navy', available: true, price: 32 },
      { color: 'Black/Lime', shopifyVariantId: 'hat-black', available: true, price: 32 },
      { color: 'White/Navy', shopifyVariantId: 'hat-white', available: true, price: 32 },
      { color: 'Gray/Black', shopifyVariantId: 'hat-gray', available: false, price: 32 }
    ],
    features: ['Premium embroidered logo', 'Structured 6-panel design', 'Adjustable snapback', 'Moisture-wicking sweatband'],
    badge: 'BESTSELLER',
    featured: true,
    rating: 4.8,
    reviewCount: 134
  },
  {
    id: 'pickleball-sport-bag',
    shopifyProductId: 'pbx-pickleball-sport-bag',
    name: 'PBX Pickleball Sport Bag',
    description: 'Premium sport bag designed specifically for pickleball players and equipment.',
    price: 55,
    images: {
      main: getDemoImage('sport-bag', 'main'),
      gallery: [
        getDemoImage('sport-bag', 'open'),
        getDemoImage('sport-bag', 'compartments'),
        getDemoImage('sport-bag', 'carrying')
      ]
    },
    category: 'accessories',
    subcategory: 'bags',
    variants: [
      { color: 'Black/Lime', shopifyVariantId: 'bag-black', available: true, price: 55 },
      { color: 'Navy/White', shopifyVariantId: 'bag-navy', available: true, price: 55 },
      { color: 'Gray/Orange', shopifyVariantId: 'bag-gray', available: false, price: 55 }
    ],
    features: ['Dedicated paddle compartments', 'Ventilated shoe pocket', 'Water-resistant fabric', 'Adjustable shoulder straps'],
    badge: 'BESTSELLER',
    featured: true,
    rating: 4.9,
    reviewCount: 203
  },
  {
    id: 'over-grips-3pack',
    shopifyProductId: 'pbx-over-grips-3pack',
    name: 'PBX Over-grips (3-Pack)',
    description: 'Premium over-grips for enhanced paddle control and comfort.',
    price: 12,
    images: {
      main: getImagePath('accessories', 'over-grips'),
      gallery: [
        getImagePath('accessories', 'over-grips', 'pack.jpg'),
        getImagePath('accessories', 'over-grips', 'installed.jpg'),
        getImagePath('accessories', 'over-grips', 'colors.jpg')
      ]
    },
    category: 'accessories',
    subcategory: 'equipment',
    variants: [
      { color: 'White (3-pack)', shopifyVariantId: 'grips-white', available: true, price: 12 },
      { color: 'Black (3-pack)', shopifyVariantId: 'grips-black', available: true, price: 12 },
      { color: 'Lime (3-pack)', shopifyVariantId: 'grips-lime', available: true, price: 12 },
      { color: 'Mixed (3-pack)', shopifyVariantId: 'grips-mixed', available: false, price: 12 }
    ],
    features: ['Superior grip and feel', 'Sweat-absorbing material', 'Easy installation', 'Long-lasting durability'],
    badge: 'NEW',
    featured: false,
    rating: 4.6,
    reviewCount: 156
  },
  {
    id: 'lead-paddle-weights',
    shopifyProductId: 'pbx-lead-paddle-weights',
    name: 'PBX Lead Paddle Weights (10-Pack)',
    description: 'Professional lead tape for paddle customization and power enhancement.',
    price: 15,
    images: {
      main: getImagePath('accessories', 'paddle-weights'),
      gallery: [
        getImagePath('accessories', 'paddle-weights', 'pack.jpg'),
        getImagePath('accessories', 'paddle-weights', 'application.jpg'),
        getImagePath('accessories', 'paddle-weights', 'paddle.jpg')
      ]
    },
    category: 'accessories',
    subcategory: 'equipment',
    variants: [
      { shopifyVariantId: 'weights-10pack', available: true, price: 15 }
    ],
    features: ['Professional-grade lead tape', 'Easy application and removal', 'Customizable weight placement', 'Enhanced paddle power'],
    featured: false,
    rating: 4.4,
    reviewCount: 78
  }
];

// Helper functions to filter products by category
export const getMensProducts = () => enhancedProducts.filter(p => p.category === 'mens');
export const getWomensProducts = () => enhancedProducts.filter(p => p.category === 'womens');
export const getAccessoriesProducts = () => enhancedProducts.filter(p => p.category === 'accessories');
export const getFeaturedProducts = () => enhancedProducts.filter(p => p.featured);

// Get products by subcategory
export const getProductsBySubcategory = (subcategory: string) => 
  enhancedProducts.filter(p => p.subcategory === subcategory);

// Export helper functions for external use
export { getImagePath, getPlaceholderImage }; 